import { Post } from '../Resources/index.js'
import { useState } from 'react';
import { useForm } from 'react-hook-form'

const RegisterUser = () => {

    const { register, handleSubmit, formState: { errors } } = useForm();

    const [submitTrigger, setSubmitTrigger] = useState(false)
    const [valueForm, setValueForm] = useState({})


    function onSubmit(data) {
        setSubmitTrigger(true)
        setValueForm(data)
    }



    return (
        <>
            <h1>Insira os dados abaixo:</h1>
            <form onSubmit={handleSubmit(onSubmit)}>

                <input {...register('name', { required: true })} placeholder='Nome' />
                <input {...register('email', { required: true })} placeholder='Seu email' />

                <input type='submit' />

            </form>
            {submitTrigger && (
                <Post valorValueForm={valueForm}/>
            )}

        </>

    )

}

export default RegisterUser